import {request} from '@/network/request'

export function helpDocuments(query) {
  return request({
    url: '/gaoligong/helpDocuments/page',
    method: 'get',
    params: query
  })
}

export function addObj(obj) {
  return request({
    url: '/gaoligong/helpDocuments',
    method: 'post',
    data: obj
  })
}

export function getObj(id) {
  return request({
    url: '/gaoligong/helpDocuments/' + id,
    method: 'get'
  })
}

export function delObj(id) {
  return request({
    url: '/gaoligong/helpDocuments/' + id,
    method: 'delete'
  })
}

export function putObj(obj) {
  return request({
    url: '/gaoligong/helpDocuments',
    method: 'put',
    data: obj
  })
}
